<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="600px">
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="text--subtitle">
            <v-icon color="primary" style="padding-bottom: 2px"
              >mdi-cancel</v-icon
            >
            {{ $t('message.cancelUpload') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="px-5 pt-0 pb-4">
          {{ $t('message.wannaCancelUpload') }}
        </v-card-text>
        <v-card-actions class="px-8 pb-6">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="px-10" @click="handleClose">
            <span class="mx-3">{{ $t('message.continueUpload') }}</span>
          </v-btn>
          <v-btn text class="px-4" @click="handleCancelUploadList">
            <span class="mx-3">{{ $t('message.cancelUpload') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'ConfirmCancelUpload',
  components: {},
  data: () => ({
    open: false,
  }),
  mounted() {
    this.$root.$on('confirmCancelUploadModal', () => {
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('confirmCancelUploadModal')
  },
  methods: {
    handleClose() {
      this.open = false
    },
    handleCancelUploadList() {
      this.$root.$emit('cancelUploadList')
      this.handleClose()
    },
  },
}
</script>

<style>
.cardTitle {
  font-weight: 600;
  font-size: 34px;
  line-height: 36px;
}
</style>
